import { AnyPartItem } from "../stores/slices/cartSlice";
import {
  NormalizedPartData,
  normalizePartData,
} from "../util/normalizePartData";
import { useLanguage } from "./useLanguage";

interface NormalizePartDataHook {
  (part: AnyPartItem): NormalizedPartData;
  (part: AnyPartItem | null | undefined): NormalizedPartData | null;
}

export const useNormalizedPartData: NormalizePartDataHook = (part) => {
  const [language] = useLanguage();
  return normalizePartData(part, language) as NormalizedPartData;
};
